export default __webpack_public_path__ + "static/media/theme2net.1b9ee2eb.png";